import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ListGroup, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';

import ChatList from './ChatList';
import { API_SERVER } from '../../../../config/constant';
import { LOGOUT } from './../../../../store/actions';

import avatar1 from '../../../../assets/images/user/avatar-1.jpg';
import avatar2 from '../../../../assets/images/user/avatar-2.jpg';

const NavRight = () => {

    // ...existing code...
    const [listOpen, setListOpen] = useState(false)
    // const [notificaciones, setData] = useState([])

    const account = useSelector((state) => state.account)

    const dispatcher = useDispatch()

    const handleLogout = () => {
        axios
            .post(API_SERVER + 'users/logout', {}, { headers: { Authorization: `${account.token}` } })
            .then(function (response) {
                // Force the LOGOUT
                //if (response.data.success) {
                dispatcher({ type: LOGOUT });
                //} else {
                //    console.log('response - ', response.data.msg);
                //}
            })
            .catch(function (error) {
                console.log('error - ', error);
            });
    };

    // const removeNotifications = () => {
    //     setLoading(true)
    //     axios
    //         .post('https://9a41neo066.execute-api.eu-west-1.amazonaws.com/dev/notificaciones/solicitud/delete', account)
    //         .then(function (response) {
    //             if (response.data.success) {
    //                 setData([]);
    //                 setLoading(false)
    //             } else {
    //                 console.log('ko');
    //             }
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         })
    // };

    // useEffect(() => {
    //     console.log('account enviado a notificaciones/solicitud/read:', account);
    //     axios
    //         .post('https://dev-backend.fcf.services/notificaciones/solicitud/read', account)
    //         .then(function (response) {
    //             if (response.data.success) {
    //                 setData(response.data.result.data);
    //             } else {
    //                 console.log('ko');
    //             }
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //         })
    // }, [account])

    // const notificacionesStyle = {
    //     background: "#007bff",
    //     borderRadius: "50%",
    //     height: "19px",
    //     width: "19px",
    //     lineHeight: "18px",
    //     display: "inline-block",
    //     textAlign: "center",
    //     position: "relative",
    //     fontSize: "0.8em",
    //     color: "white",
    //     top: "-9px"
    // };

    return (
        <React.Fragment>
            <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto" id="navbar-right">
                <ListGroup.Item as="li" bsPrefix=" ">
                    <Dropdown className="drp-user">
                        <Dropdown.Toggle as={Link} variant="link" to="#" id="dropdown-basic">
                            <i className="icon feather icon-user" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight className="profile-notification">
                            <div className="pro-head">
                                <img src={parseInt(account.data.gender) === 1 ? avatar2 : avatar1} className="img-radius" alt="User Profile" />
                                <span>
                                    {account.user}
                                </span>
                                <Link to="#" className="dud-logout" onClick={handleLogout} title="Logout">
                                    <i className="feather icon-log-out" />
                                </Link>
                            </div>
                            <ListGroup as="ul" bsPrefix=" " variant="flush" className="pro-body">
                                <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="" className="dropdown-item">
                                        <i className="feather icon-users" /> {account.data.profile}
                                    </Link>
                                </ListGroup.Item>
                                <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item" onClick={handleLogout}>
                                        <i className="feather icon-log-out" /> Logout
                                    </Link>
                                </ListGroup.Item>
                            </ListGroup>
                        </Dropdown.Menu>
                    </Dropdown>
                </ListGroup.Item>
            </ListGroup>
            <ChatList listOpen={listOpen} closed={() => setListOpen(false)} />
        </React.Fragment>
    );
};

export default NavRight;
